import React from 'react'
import PropTypes from 'prop-types'
import remark from 'remark';
import remarkRecommended from 'remark-preset-lint-recommended';
import remarkHtml from 'remark-html';
import './html-content.scss'

const HTMLContent = ({ content }) => {
  const html = remark()
    .use(remarkRecommended)
    .use(remarkHtml)
    .processSync(content).toString();
    
  return (
    <div className={`html-content`} dangerouslySetInnerHTML={{ __html: html }} />
  )
}

HTMLContent.propTypes = {
  content: PropTypes.string
}

export default HTMLContent



// WEBPACK FOOTER //
// ./src/components/html-content/html-content.js